export default __webpack_public_path__ + "static/media/mini_chart.767b16f1.png";